<template>
  <div class="inputField" :class="{ inputInvalid: checkValidity && !isValid }">
    <label class="textBold" :for="fieldId">
      {{ $t("bnpl:special_field.customer.post_code.label") }}
      <span v-if="required" class="bold" style="color: var(--systemError)"
        >*</span
      >
    </label>
    <input
      :id="fieldId"
      v-model="model"
      class="textInput"
      type="number"
      autocomplete="postal-code"
      @blur="blur"
      @input="onInput"
    />
  </div>
</template>

<script setup>
import { useProfileStore } from "~~/stores/profile";

const props = defineProps({
  fieldId: {
    type: String,
    required: true,
  },
  required: {
    type: Boolean,
    required: true,
  },
  checkValidity: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(['input', 'update']);

const model = ref("");

const profileStore = useProfileStore();

const isValid = computed(() => {
  if (!props.required) return true;
  if (model.value) return true;
  return false;
});

onBeforeMount(() => {
  model.value = profileStore.postCode;
  if (model.value) {
    emit("input", model.value);
  }
});

const onInput = () => {
  profileStore.updateLocalZip(model.value);
  emit("update", model.value);
}

const blur = () => {
  profileStore.customerUpdate({ postCode: model.value });
  emit("input", model.value);
};
</script>

<style scoped lang="scss"></style>
